export default __webpack_public_path__ + "78734bdd97a8bb9105dd76e40e08f31d.png";